
import { Component, Prop, Vue } from "vue-property-decorator";
import PModal from "@/components/look/PModal.vue";
import { IClientExtradata } from "@/entities";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import Multiselect from "vue-multiselect";
import { BARCODE, EXTRADATA_TYPE } from "@/constans";

@Component({
  name: "add-edit-extradata-modal",
  components: {
    Multiselect,
    PModal,
    ValidationObserver,
    ValidationProvider,
  },
})
export default class AddEditExtradataModal extends Vue {
  @Prop({ required: true })
  extradataList!: IClientExtradata[];
  @Prop({ required: false })
  extradata?: IClientExtradata;

  private name: string | undefined = "";
  private label: string | undefined = "";
  private type: string | undefined = "";
  private attr1: string | undefined = "";
  private required: boolean | undefined = false;
  private typeOptions = Object.values(EXTRADATA_TYPE);
  private barcodeTypes = Object.values(BARCODE);
  private dataType = EXTRADATA_TYPE;

  constructor() {
    super();
  }

  async mounted(): Promise<void> {
    extend("name_unique", {
      validate: async () => {
        if (this.name) {
          return !this.extradataList?.find((ex) => this.extradata !== ex && ex.name === this.name);
        }
        return true;
      },
      message: () => this.$t("validation.messages.extradataNameAlreadyExists") as string,
    });
  }

  initData(): void {
    this.name = this.extradata?.name;
    this.label = this.extradata?.label;
    this.type = this.extradata?.type;
    this.attr1 = this.extradata?.attr1;
    this.required = this.extradata?.required;
  }

  async onSubmit(): Promise<void> {
    if (this.extradata) {
      this.extradata.label = this.label;
      this.extradata.type = this.type;
      this.extradata.attr1 = this.attr1;
      this.extradata.required = this.required;
    } else {
      const newExtradata = {
        name: this.name,
        label: this.label,
        type: this.type,
        attr1: this.attr1,
        required: this.required,
      } as IClientExtradata;

      this.extradataList.push(newExtradata);
    }
    this.$bvModal.hide("addEditExtradataModal");
  }
}
